<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      navigationPath="HelpDeskTechnicianRequestView"
      navigationField="displayID"
      :selectionEnabled="false"
      :onRowClicked="onRowClicked"
      :onLoaded="onLoaded"
      :onCellPrepared="onCellPrepared"
      name="HelpDeskTechnicianRequests"
    ></dx-grid>

    <CreateTicketByTech
      v-model="newTicketTech"
      @newTicketSended="reloadGrid()"
    />
    <v-dialog
      :style="{ padding: '0 !important' }"
      v-model="dashboardDialog"
      max-width="1000"
    >
      <DashboardSummary
        v-if="loadDashboard"
        :isDialog="true"
        @closeDashboardDialog="dashboardDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import CreateTicketByTech from "./CreateTicketByTech.vue";
import PortalUserAutocomplete from "./PortalUserAutocomplete.vue";
import DashboardSummary from "./DashboardSummary.vue";
import {
  statusIcon,
  statusIconColor,
  getPriorityColor,
  statusClosed,
} from "./helpDeskHelpers";
export default {
  metaInfo() {
    return {
      title: `${this.title}`,
    };
  },
  components: {
    CreateTicketByTech,
    PortalUserAutocomplete,
    DashboardSummary,
  },
  data: () => ({
    filterTicketsNeedingAttention: false,
    title: "Support Tickets | Technician",
    url: "",
    actions: [],
    processing: false,

    activeTechnicians: [],
    filterForTechnician: "",
    selectedTechnicians: [],

    statuses: ["Open", "On Hold", "Closed"],
    filterForStatus: "",
    selectedStatuses: [],

    newTicketTech: false,

    dashboardDialog: false,
    loadDashboard: false,
    displayIdsList: [],
    rules: {
      required: (value) => !!value || "Required.",
    },

    columns: [
      {
        field: "priorityName",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          return "mdi-box-shadow";
        },
        iconColor: getPriorityColor,
      },
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: statusIcon,
        iconColor: statusIconColor,
      },
      // {
      //     label: "Status",
      //     field: "statusName",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Ticket Number",
        field: "displayID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        link: "HelpDeskTechnicianRequestView",
        template: "link-cell-template",
        cssClass: "width-100",
      },
      {
        label: "Name",
        field: "requesterName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Subject",
        field: "subject",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Created At",
        field: "createdAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Technician",
        field: "technicianName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Duration Time",
        field: "durationTime",
        visible: true,
        type: "string",
        allowFiltering: false,
        allowHeaderFiltering: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Due By",
        field: "dueByAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        sortOrder: "asc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "ETA",
        field: "dueByTimeValue",
        visible: true,
        filterValues: [],
        filterValue: null,
        allowFiltering: false,
        allowHeaderFiltering: false,
        selectedFilterOperation: null,
        template: "text-color-cell-template",
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "requestSiteName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "requesterDepartmentName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Completed Time",
        field: "completedTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Updated Time",
        field: "lastUpdatedAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },

      {
        label: "Last Sync Time",
        field: "lastSyncTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },

      {
        label: "Requester Email",
        field: "requesterEmailID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "User",
        field: "username",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Technician Email",
      //     field: "technicianEmailID",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
    ],
  }),
  methods: {
    async beforeSetupGrid() {
      await this.getTechniciansOnTickets();
      this.columns.find((c) => c.field == "dueByTimeValue").getTextColor = (
        value
      ) => {
        if (!value) return;
        if (value.startsWith("In")) {
          return "blue";
        } else {
          return "red";
        }
      };
      this.setFilter();

      this.actions.push({
        text: "Dashboard",
        align: "left",
        action: this.openDashboardDialog,
      });

      this.actions.push({
        text: "Needing Attention",
        type: "switch",
        align: "left",
        value: this.filterTicketsNeedingAttention,
        action: this.onFilterTicketsNeedingAttentionChanged,
      });

      this.actions.push({
        text: "Select Status",
        values: this.statuses,
        type: "select",
        multiple: true,
        value: this.selectedStatuses,
        onSelected: this.onStatusSelected,
      });

      this.actions.push({
        text: "Select Technicians",
        values: this.activeTechnicians,
        type: "select",
        width: "300px",
        multiple: true,
        value: this.selectedTechnicians,
        onSelected: this.onTechSelected,
      });

      this.actions.push({
        text: "Create Ticket For user",
        action: this.openNewTicketTech,
      });

      if (this.$route.query.openNewTicket) {
        this.openNewTicketTech();
      }
    },

    openNewTicketTech() {
      this.newTicketTech = true;
    },

    reloadGrid() {
      this.$refs.grid.reloadGrid();
    },
    async getTechniciansOnTickets() {
      const response = await this.$http.get(
        `api/manageengine/getTechniciansOnTickets?includeTechsWithClosedOnly=false`
      );
      this.activeTechnicians = [
        //  { text: "All Tickets", value: "" },
        { text: "Unassigned", value: "Unassigned" },
        ...response.map((tech) => ({ text: tech, value: tech })),
      ];
    },

    onTechSelected(value) {
      localStorage.setItem("technicians-filter-tech", JSON.stringify(value));
      this.selectedTechnicians = value;
      this.setFilter();
      this.$refs.grid.reloadDataSource(this.url);
    },

    onStatusSelected(value) {
      localStorage.setItem("status-filter-tech", JSON.stringify(value));
      this.selectedStatuses = value;
      this.setFilter();
      this.$refs.grid.reloadDataSource(this.url);
    },

    mapResults(results) {
      const statusClose = ["Closed", "Canceled", "Filter Decline", "Resolved"];
      this.loadDashboard = true;
      results.map((t) => {
        t.technicianName =
          t.technicianName == "UserPortal" ? "" : t.technicianName;
        if (!statusClose.includes(t.statusName)) {
          t.dueByTimeValue = this.getDueBy(t.dueByTimeValue);
        } else {
          t.dueByTimeValue = null;
        }
        if (t.durationTime) {
          t.durationTime = this.formatDuration(t.durationTime);
        }
        return t;
      });
      this.setDateFilter();
    },
    setDateFilter() {
      const dateFilter = localStorage.getItem("selected-date-filters-tech");
      if (dateFilter) {
        this.columns.forEach((c) => {
          c.filterValue = null;
          c.filterValues = [];
          c.selectedFilterOperation = null;
        });
        try {
          const filter = JSON.parse(dateFilter);
          const mapFilterToField = {
            createDate: "createdAt",
            dueDate: "dueByAt",
            completeDate: "completedTime",
          };
          filter.forEach((f) => {
            const columnField = mapFilterToField[f.type];
            const column = this.columns.find((c) => c.field === columnField);

            if (column) {
              const start = f.dateRange.split(",")[0];
              const end = f.dateRange.split(",")[1];

              if (end) {
                column.selectedFilterOperation = "between";

                column.filterValue = [
                  new Date(`${start}T00:00:00-05:00`),
                  new Date(`${end}T00:00:00-05:00`).setDate(
                    new Date(`${end}T00:00:00-05:00`).getDate() - 1
                  ),
                ];
              } else {
                column.filterValue = new Date(`${start}T00:00:00-05:00`);
              }
            }
          });
        } catch (e) {
        } finally {
          localStorage.removeItem("selected-date-filters-tech");
        }
      }
    },

    getDueBy(dueByTimeValue) {
      if (!dueByTimeValue) {
        return "MIssing Due Date";
      }
      const currentTime = new Date().getTime();

      const distance = dueByTimeValue - currentTime;

      const absDistance = Math.abs(distance);
      const days = Math.floor(absDistance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (absDistance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((absDistance % (1000 * 60)) / 1000);

      const timeStr = `${days ? days + " days" : ""} ${
        hours ? hours + " hours" : ""
      }  ${minutes} minutes`;

      if (distance >= 0) {
        return `In ${timeStr}`;
      } else {
        return `Delay by ${timeStr}`;
      }
    },

    formatDuration(milliseconds) {
      if (!milliseconds || milliseconds === 0) return "";

      const totalSeconds = Math.floor(milliseconds / 1000);
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;

      const parts = [];
      if (days > 0) {
        parts.push(`${days} ${days === 1 ? "day" : "days"}`);
      }
      if (hours > 0) {
        parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
      }
      if (minutes > 0) {
        parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
      }
      if (seconds > 0 && parts.length === 0) {
        parts.push(`${seconds} ${seconds === 1 ? "second" : "seconds"}`);
      }

      return parts.length > 0 ? parts.join(" ") : "0 seconds";
    },
    async syncOpenTickets() {
      try {
        await this.$http.post(`api/manageengine/UpdateOpenTickets`);
        this.reloadGrid();
        this.$notify({
          text: "Open Tickets Syncked",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      }
    },

    setFilter() {
      var savedTechniciansFilter = localStorage.getItem(
        "technicians-filter-tech"
      );
      var savedStatusFilter = localStorage.getItem("status-filter-tech");

      var savedFilterTicketsNeedingAttention = localStorage.getItem(
        "filterTicketsNeedingAttention-tech"
      );
      if (savedFilterTicketsNeedingAttention) {
        this.filterTicketsNeedingAttention =
          savedFilterTicketsNeedingAttention == "true" ? true : false;
      }

      if (savedTechniciansFilter) {
        try {
          this.selectedTechnicians = JSON.parse(savedTechniciansFilter);
          if (!Array.isArray(this.selectedTechnicians)) {
            this.selectedTechnicians = savedTechniciansFilter
              ? [savedTechniciansFilter]
              : [];
          }
        } catch (e) {
          this.selectedTechnicians = savedTechniciansFilter
            ? [savedTechniciansFilter]
            : [];
        }
      } else {
        this.selectedTechnicians = [];
      }
      this.filterForTechnician =
        this.selectedTechnicians.length > 0
          ? this.selectedTechnicians.join(", ")
          : "";

      if (savedStatusFilter) {
        try {
          this.selectedStatuses = JSON.parse(savedStatusFilter);
          if (!Array.isArray(this.selectedStatuses)) {
            this.selectedStatuses = savedStatusFilter
              ? [savedStatusFilter]
              : [];
          }
        } catch (e) {
          this.selectedStatuses = savedStatusFilter ? [savedStatusFilter] : [];
        }
      } else {
        this.selectedStatuses = [];
      }

      this.filterForStatus =
        this.selectedStatuses.length > 0
          ? this.selectedStatuses.join(", ")
          : "";

      this.url = `manageengine?statuses=${this.filterForStatus}&technicians=${
        this.filterForTechnician
      }&filterForUserId=false&filterTicketsNeedingAttention=${
        this.filterTicketsNeedingAttention
      }`;
    },

    onFilterTicketsNeedingAttentionChanged(value) {
      localStorage.setItem("filterTicketsNeedingAttention-tech", value);
      this.filterTicketsNeedingAttention = value;
      this.setFilter();
      this.$refs.grid.reloadDataSource(this.url);
    },
    openDashboardDialog() {
      this.loadDashboard = true;
      this.dashboardDialog = true;
    },

    async loadDisplayIdsList() {
      this.displayIdsList = [];
      const data = this.$refs.grid.grid.getDataSource().items();
      data.forEach((row) => {
        this.displayIdsList.push(row.displayID);
      });
    },

    async onRowClicked(row) {
      await this.loadDisplayIdsList();
      this.$router.push({
        name: "HelpDeskTechnicianRequestView",
        params: { id: row.displayID },
        query: this.displayIdsList,
      });
    },

    onLoaded(results) {
      this.mapResults(results);
    },
    onCellPrepared(e) {
      if (
        e &&
        e.values &&
        !statusClosed.includes(e.row.key.statusName) &&
        ((e && e.values && e.row.key.dueByAt < new Date()) ||
          (e && e.values && e.row.key.dueByAt == null))
      ) {
        if ((e.rowIndex + 1) % 2 === 0) {
          e.cellElement.style.setProperty(
            "background-color",
            "#ffd6d6",
            "important"
          );
        } else {
          e.cellElement.style.setProperty(
            "background-color",
            "#f7e1e1",
            "important"
          );
        }
      }
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
